import React, { useMemo } from 'react'
import { ContentTypeWithImageData, ModelType } from '../../../types'
import BlogItem from './BlogItem'
import BlogJsonLd from './BlogJson'
import { getDisplayBlogItems } from './uitls'

type Props = {
    model: Pick<ModelType, "id" | "name" | "modelId" | "transformations">
    content: Pick<ContentTypeWithImageData, "id" | "modelId" | "data" | "imageFile">[]
    displayCount?: number
    showJsonLd?: boolean
}

export default function BlogItemList({ model, content, showJsonLd, displayCount = 6 }: Props) {

    const [currentDisplayCount, setCurrentDisplayCount] = React.useState(displayCount);

    const contentToShow = useMemo(() => getDisplayBlogItems(content, currentDisplayCount), [content, currentDisplayCount]);

    return (
        <>
            {contentToShow.map((content) => {
                if (!content.ogContent) { return <></>; }
                return <BlogItem key={content.id} model={model} content={content.ogContent} contentData={content} />
            })}
            {showJsonLd && <BlogJsonLd model={model} content={contentToShow} />}
        </>
    )
}
